
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle 
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, Settings as SettingsIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslations } from "use-intl";
import { isUserPermissionsEnabled } from "@/config/features";
import { CompanyContextSettings } from "@/components/settings/CompanyContextSettings";
import { CompanySellerInfoSettings } from "@/components/settings/CompanySellerInfoSettings";
import { CompanyBankgiroSettings } from "@/components/settings/CompanyBankgiroSettings";
import { FiscalYearSettings } from "@/components/settings/FiscalYearSettings";
import { DataExportSettings } from "@/components/settings/DataExportSettings";
import { EmployeeSettings } from "@/components/settings/EmployeeSettings";
import { CardSettings } from "@/components/settings/CardSettings";

const Settings = () => {
  const t = useTranslations("consultantSettings.page");
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold tracking-tight">{t("title")}</h1>

      {/* Company Context Settings - Full Width */}
      <CompanyContextSettings />

      {/* Company Seller Info (invoicing) Settings - Full Width */}
      <CompanySellerInfoSettings />

      {/* Payment details: bankgiro per connected account (FIN-818) */}
      <CompanyBankgiroSettings />

      {/* Fiscal Year Settings - Full Width */}
      <FiscalYearSettings />

      {/* Data Export Settings - Full Width */}
      <DataExportSettings />

      {/* Employee Settings - Full Width */}
      <EmployeeSettings />

      {/* Card Settings - Full Width */}
      <CardSettings />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Users className="h-5 w-5" />
              {t("users.title")}
            </CardTitle>
            <CardDescription>
              {t("users.description")}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground mb-4">
              {t("users.body")}
            </p>
            <Button asChild>
              <Link to="/user-management">
                {t("users.action")}
              </Link>
            </Button>
          </CardContent>
        </Card>

        {isUserPermissionsEnabled() && (
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Users className="h-5 w-5" />
                {t("permissions.title")}
              </CardTitle>
              <CardDescription>
                {t("permissions.description")}
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground mb-4">
                {t("permissions.body")}
              </p>
              <Button asChild>
                <Link to="/user-permissions">
                  {t("permissions.action")}
                </Link>
              </Button>
            </CardContent>
          </Card>
        )}

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <SettingsIcon className="h-5 w-5" />
              {t("application.title")}
            </CardTitle>
            <CardDescription>
              {t("application.description")}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              {t("application.body")}
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Settings;
